module.exports = __webpack_public_path__ + "img/folder-dark-blue.92003b7b.svg";